import { z } from 'zod';

export const emailValidator = (_shape?: z.ZodTypeAny) =>
	z
		.string()
		.nullish()
		.transform(v => v ?? '')
		.pipe(
			z
				.string()
				.trim()
				.pipe(
					z.union([
						z.literal(''),
						z.string().email({ message: 'Invalid email address' })
					])
				)
		);
